import { generateClient } from "aws-amplify/api";
import { articleByCategory, articleByName } from "../graphql/queries";

export async function getArticlesByTopic(category) {
  const client = generateClient();
  let nextToken = null;

  try {
    const response = await client.graphql({
      query: articleByCategory,
      variables: {
        category: category,
        limit: 10,
        nextToken: nextToken,
      },
    });

    const articlesList = response.data.articleByCategory.items.map(
      (item) => item.articleName
    );
    return articlesList;
  } catch (error) {
    console.log("Failed to fetch articles by topic:", error);
  }
}

export async function getArticleByName(name) {
  const client = generateClient();

  try {
    const response = await client.graphql({
      query: articleByName,
      variables: {
        articleName: name,
      },
    });

    const article = response.data.articleByName.items[0].articleText;
    return article; // Return the article content
  } catch (error) {
    console.log("Failed to fetch articles by name:", error);
    return null; // Return null in case of an error
  }
}
